/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {StepIndicatorStatic, StepIndicatorStrict, StepIndicatorLoose, StepIndicatorCustomized, StepIndicatorSidebar, StepIndicatorTextOnly, StepIndicatorCustomRenderer, StepIndicatorRouter} from 'Docs/uilib/components/step-indicator/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "StepIndicator in loose mode"
    }), "\n", _jsx(_components.p, {
      children: "Every step can be clicked."
    }), "\n", _jsxs(_components.p, {
      children: ["You want to place ", _jsx(_components.code, {
        children: "<StepIndicator.Sidebar sidebar_id=\"unique-id-loose\" />"
      }), " somewhere in your layout."]
    }), "\n", _jsx(StepIndicatorLoose, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator in strict mode"
    }), "\n", _jsx(_components.p, {
      children: "Every visited step can be clicked, including the current step."
    }), "\n", _jsxs(_components.p, {
      children: ["You want to place ", _jsx(_components.code, {
        children: "<StepIndicator.Sidebar sidebar_id=\"unique-id-strict\" />"
      }), " somewhere in your layout."]
    }), "\n", _jsx(StepIndicatorStrict, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator in static mode"
    }), "\n", _jsx(_components.p, {
      children: "None of the steps are clickable."
    }), "\n", _jsxs(_components.p, {
      children: ["You want to place ", _jsx(_components.code, {
        children: "<StepIndicator.Sidebar sidebar_id=\"unique-id-static\" />"
      }), " somewhere in your layout."]
    }), "\n", _jsx(StepIndicatorStatic, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator with sidebar"
    }), "\n", _jsx(StepIndicatorSidebar, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator with a router"
    }), "\n", _jsx(StepIndicatorRouter, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator customized"
    }), "\n", _jsx(_components.p, {
      children: "Completely customized step indicator."
    }), "\n", _jsx(StepIndicatorCustomized, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator with text only"
    }), "\n", _jsx(StepIndicatorTextOnly, {}), "\n", _jsx(_components.h3, {
      children: "StepIndicator with a custom renderer."
    }), "\n", _jsx(StepIndicatorCustomRenderer, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
